import {Header} from '../model/header.model';

export function getPropValue(sourceObject: any, dotNotationPath: string): string {
  if (!sourceObject || !dotNotationPath) return '';
  let returnData = sourceObject;
  dotNotationPath.split('.').forEach(subPath => {
    if (returnData === null || returnData === undefined) {
      returnData = '';
      return;
    }
    if (Array.isArray(returnData)) {
      returnData = returnData[0] ? returnData[0][subPath] : '';
      return;
    }
    returnData = returnData[subPath] !== undefined ? returnData[subPath] : '';
  });
  return returnData;
}

export function dateFormatYYYYMMDDTODDMMYYYY(input: string): string {
  if (!input) return '';
  const parts = input.split('-');
  if (parts.length !== 3) {
    return input;
  }
  const [year, month, day] = parts;
  return `${day}.${month}.${year}`;
}

export function formatCellValue(row: any, header: Header): string {
  let value = getPropValue(row, header.key);

  if (header.date && value) {
    value = dateFormatYYYYMMDDTODDMMYYYY(value);
    if (header.addKey) {
      const addValue = getPropValue(row, header.addKey);
      if (addValue) {
        value += ' ' + addValue.substring(0, 6);
      }
    }
  }

  return value || '';
}
